<template>
	<button
		v-if="environmentShouldShowToggle && hasAlternateFormClass"
		class="absolute top-6 right-10 bg-[#e6e9f0]! px-4 py-2 text-sm text-black! hover:bg-gray-300!"
		@click="handleUseAlternateFormClass"
	>
		{{ sessionDocumentsStore.useAlternateFormClass ? 'New' : 'Old' }} Form Fill
	</button>
</template>

<script setup lang="ts">
import { useFoxitManager } from '@/components/documents/Foxit/composables/FoxitManager'
import { getDocumentRule } from '@/data/documentRules'
import { useSessionStore } from '@/stores/session'
import { useSessionDocumentsStore } from '@/stores/sessionDocuments'
import { computed } from 'vue'

const sessionStore = useSessionStore()
const sessionDocumentsStore = useSessionDocumentsStore()
const { confirmResetForm } = useFoxitManager()

const hasAlternateFormClass = computed(() => {
	const stateCode = sessionStore.activeFh?.billingAddress?.stateCode ?? ''
	const formType = sessionDocumentsStore.currentDocument?.meta.type
	const documentRule = getDocumentRule(stateCode, formType!)

	return !!documentRule?.alternateFormClass
})

/** Get the current environment by hostname and return the appropriate label **/
const environmentName = computed(() => {
	const host = window.location.hostname

	if (host.includes('studio-author')) return 'Author'
	if (host.includes('studio-demo')) return 'Demo'
	if (host.includes('studio-dev')) return 'Dev'
	if (host.includes('studio-stage')) return 'Stage'
	if (host.includes('studio.precoa.com')) return null

	return 'Local'
})

const environmentShouldShowToggle = computed(() => {
	return ['Dev', 'Stage', 'Local'].includes(environmentName.value ?? '')
})

const handleUseAlternateFormClass = async () => {
	await sessionDocumentsStore.setPageState('pending')
	sessionDocumentsStore.useAlternateFormClass =
		!sessionDocumentsStore.useAlternateFormClass
	sessionDocumentsStore.setStepAutoFilled(
		sessionDocumentsStore.currentStep!,
		false
	)
	await confirmResetForm()
}
</script>
